module.exports = __webpack_public_path__ + "img/back_btn_black.741802ed.svg";